import { format, parse } from 'libphonenumber-js';

import fromAnyToSpacelessString from 'utils/converters/fromAnyToSpacelessString.util';
import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';

const L = logger('parsePhone');

const PHONE_NUMBER_FORMAT = 'E.164';

const parsePhone = withOptions(({ phoneNumber, countryCode }) => {
  try {
    // just making sure it is a string with no empty spaces
    const string = fromAnyToSpacelessString(phoneNumber);

    // library will parse the string based on the country code
    const parsed = parse(string, countryCode);

    return format(parsed, PHONE_NUMBER_FORMAT);
  } catch (e) {
    L.warn('()', e);
    return '';
  }
});

// noinspection JSUnusedGlobalSymbols
export default parsePhone;
